import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { convertPxToVw } from '../../utils';
let Rich = class Rich extends Vue {
    get richStyle() {
        return {
            padding: '0 ' + convertPxToVw(this.data.compMargin) + 'vw',
            background: this.data.bgColor || '#FFFFFF',
        };
    }
    change(newV) {
        console.log(newV);
    }
    created() { }
};
tslib_1.__decorate([
    Prop()
], Rich.prototype, "data", void 0);
tslib_1.__decorate([
    Watch('data.content.value', { deep: true })
], Rich.prototype, "change", null);
Rich = tslib_1.__decorate([
    Component({})
], Rich);
export default Rich;
